import { useEffect, useMemo, useState } from 'react';
import { searchList } from '@/services/list.service';
import debounce from 'lodash/debounce';
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';

const useListSearch = (removeLists) => {
  const [listSearchQuery, setListSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { dropdownLists } = useSelector((state) => state.list);
  const [filteredList, setFilteredList] = useState(() => (dropdownLists ? dropdownLists : []));

  const fetchLists = async (query = '') => {
    setIsLoading(true);
    try {
      const response = await searchList({ query, includeArchived: false });
      let lists = response.data;
      if (removeLists?.length) {
        lists = lists.filter((list) => !removeLists.includes(list._id));
      }
      setFilteredList(lists);
    } catch (error) {
      NotificationManager.error('Failed to fetch lists');
      setFilteredList(dropdownLists);
    } finally {
      setIsLoading(false);
    }
  };

  const debouncedFetchLists = useMemo(
    () =>
      debounce((query) => {
        if (query.length > 0) {
          fetchLists(query);
        } else {
          setFilteredList(dropdownLists);
        }
      }, 300),
    [removeLists]
  );

  const onListSearch = (text) => {
    setListSearchQuery(text);
    debouncedFetchLists(text);
  };

  useEffect(() => {
    return () => {
      // Clean up debounce on unmount
      debouncedFetchLists.cancel();
    };
  }, [debouncedFetchLists]);

  return {
    onListSearch,
    listSearchQuery,
    filteredList,
    isLoading,
  };
};

export default useListSearch;
